// MSW (Mock Service Worker) is intentionally disabled.
//
// The app uses the real DayBright API for every request, but the original
// Vuetify template wired MSW into `registerPlugins` which intercepted every
// fetch and forwarded unmatched requests via `passthrough()`. That caused
// confusing "Failed to fetch" errors for any URL the demo handlers didn't
// recognise.
//
// Handler modules still live under `./handlers/**` because demo/template
// pages (ecommerce, email, kanban, profile, etc.) import them as type or
// data sources. Those pages are not part of the active product, but their
// imports must still resolve at build time. Once the demo views are removed,
// the entire `fake-api` folder can be deleted.
//
// Default export is a no-op so `registerPlugins` finds nothing to start.
export default function () {}
